<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start stretch">
    <div *ngIf="program" class="mb-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="start center">
            <div *ngIf="program.image; else programIcon" class="mr-8">
                <img class="avatar mr-0" [alt]="program.name" [src]="program.image.thumbUrl" />
            </div>
            <ng-template #programIcon>
                <div class="avatar module-icon-container mr-8" fxLayout="row" fxLayoutAlign="center center">
                    <mat-icon [svgIcon]="program | getModuleIcon"></mat-icon>
                </div>
            </ng-template>

            <div fxLayout="column">
                <span class="text-gray-700 font-medium">{{ program.name }}</span>
                <span class="text-gray-400" *ngIf="program.version">{{ program.version }}</span>
            </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="end center" class="ml-16">
            <span class="text-gray-600 mr-12">{{ 'PAGE.DIALOG.REMOVE_AS_PARTICIPANT.LABEL.REMOVE_FROM_ALL_EXECUTIONS' | translate }}</span>
            <mat-checkbox [checked]="removeFromAllExecutions" (change)="onRemoveFromAllChange($event.checked)" color="accent"></mat-checkbox>
        </div>
    </div>

    <ng-container *ngIf="isSingleParticipant; else multiParticipantView">
        <div
            class="execution-row rounded p-16"
            fxLayout="row"
            fxLayoutAlign="space-between center"
            *ngFor="let relevantExecution of participantBookings[0].relevantExecutions; let isLast = last"
            [class.mb-8]="!isLast"
        >
            <ng-container *ngTemplateOutlet="executionContent; context: { relevantExecution: relevantExecution }"></ng-container>
        </div>
    </ng-container>

    <ng-template #multiParticipantView>
        <div *ngFor="let participantBooking of participantBookings; let isLast = last" [class.mb-8]="!isLast">
            <mat-accordion multi>
                <mat-expansion-panel class="mat-elevation-z0 py-8" [expanded]="false">
                    <mat-expansion-panel-header fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100-p">
                            <mat-panel-title>
                                <div fxLayout="row" fxLayoutAlign="flex-start center">
                                    <div class="relative mr-16">
                                        <img
                                            class="avatar mr-0"
                                            *ngIf="participantBooking.user.profilePicture?.src; else initials"
                                            [alt]="participantBooking.user.fullName"
                                            [src]="participantBooking.user.profilePicture?.src"
                                        />
                                        <ng-template #initials>
                                            <div fxLayoutAlign="center center" class="avatar-initials avatar mr-0">{{ participantBooking.user.fullName | initials }}</div>
                                        </ng-template>
                                    </div>

                                    <div fxLayout="column" class="text-gray-600">
                                        <span>{{ participantBooking.user.fullName }}</span>
                                        <span class="text-gray-400">{{ participantBooking.user.email }}</span>
                                    </div>
                                </div>
                            </mat-panel-title>
                        </div>
                    </mat-expansion-panel-header>
                    <div class="mt-4">
                        <div
                            class="execution-row rounded p-16"
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            *ngFor="let relevantExecution of participantBooking.relevantExecutions; let isLastExecution = last"
                            [class.mb-8]="!isLastExecution"
                        >
                            <ng-container *ngTemplateOutlet="executionContent; context: { relevantExecution: relevantExecution }"></ng-container>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </ng-template>
</div>

<ng-template #executionContent let-relevantExecution="relevantExecution">
    <div fxLayout="row" fxLayoutAlign="start center" class="min-w-0 mr-16">
        <div *ngIf="relevantExecution.image; else relevantExecutionIconType" class="mr-16">
            <img class="avatar mr-0" [alt]="relevantExecution.name" [src]="relevantExecution.image.thumbUrl" />
        </div>
        <ng-template #relevantExecutionIconType>
            <div class="avatar module-icon-container mr-16" fxLayout="row" fxLayoutAlign="center center">
                <mat-icon [svgIcon]="relevantExecution | getModuleIcon"></mat-icon>
            </div>
        </ng-template>

        <div fxLayout="column" class="min-w-0 text-gray-600">
            <span class="mb-4 text-truncate" [tooltipIfTruncated]="relevantExecution.name">{{ relevantExecution.name }}</span>
            <span class="text-gray-400">{{ relevantExecution.startDate | date: 'shortDate' }} - {{ relevantExecution.endDate | date: 'shortDate' }}</span>
        </div>
    </div>

    <div class="booking-toggle shrink-0">
        <mat-button-toggle-group
            [value]="relevantExecution.isSelected ? 'unbook' : 'keep'"
            [disabled]="areExecutionActionsDisabled"
            (change)="onBookingToggleChange(relevantExecution, $event.value)"
            appearance="legacy"
            class="mat-elevation-z0 booking-toggle-group"
        >
            <mat-button-toggle value="unbook" class="unbook-toggle">{{ 'GENERAL.LABEL.UNBOOK_USER' | translate }}</mat-button-toggle>
            <mat-button-toggle value="keep" class="keep-toggle">{{ 'LISTINGS.BUTTON.KEEP_BOOKING' | translate }}</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
</ng-template>

<div mat-dialog-actions class="pt-0 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <app-flat-button [label]="'GENERAL.BUTTON.CONFIRM'" (onClick)="confirm()"></app-flat-button>
</div>
